import challengeModel from './model.js'

export default {
  challenge: challengeModel,
  challenges: [],
  revs: [],
  totalChallenges: 0,
}
